import * as i0 from '@angular/core';
import { inject, Directive, Input, HostBinding, NgModule } from '@angular/core';
import { RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';

/**
 * @deprecated use the Angular built-in feature instead:`<a routerLinkActive ariaCurrentWhenActive="page">`
 *
 * @see https://github.com/angular/angular/pull/45167
 */
class SiAriaCurrentDirective {
    /**
     * Type for `aria-current` to set if routerLink is active.
     */
    siAriaCurrent;
    routerLink = inject(RouterLinkActive, { host: true });
    get isActive() {
        return this.routerLink.isActive;
    }
    get ariaCurrent() {
        return this.isActive ? (this.siAriaCurrent ? this.siAriaCurrent : 'true') : 'false';
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiAriaCurrentDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.1.5", type: SiAriaCurrentDirective, selector: "[siAriaCurrent]", inputs: { siAriaCurrent: "siAriaCurrent" }, host: { properties: { "attr.aria-current": "this.ariaCurrent" } }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiAriaCurrentDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[siAriaCurrent]'
                }]
        }], propDecorators: { siAriaCurrent: [{
                type: Input
            }], ariaCurrent: [{
                type: HostBinding,
                args: ['attr.aria-current']
            }] } });

/**
 * @deprecated use the Angular built-in feature instead:`<a routerLinkActive ariaCurrentWhenActive="page">`
 *
 * @see https://github.com/angular/angular/pull/45167
 */
class SiAriaCurrentModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiAriaCurrentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiAriaCurrentModule, declarations: [SiAriaCurrentDirective], imports: [CommonModule], exports: [SiAriaCurrentDirective] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiAriaCurrentModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiAriaCurrentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SiAriaCurrentDirective],
                    exports: [SiAriaCurrentDirective]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SiAriaCurrentDirective, SiAriaCurrentModule };
